import { FONT_SIZE_MODIFIER_PREFIX } from '../../text-formatting/constants/font-size';
import { TEXT_INTENT_MODIFIER_PREFIX } from '../../text-formatting/constants/text-indent';

const removeUnsupportedClassNames = (element) => {
  Array.from(element.classList).forEach((className) => {
    if (
      [FONT_SIZE_MODIFIER_PREFIX, TEXT_INTENT_MODIFIER_PREFIX].some((prefix) =>
        className.startsWith(prefix)
      )
    )
      return;
    element.classList.remove(className);
  });

  if (element.classList.length === 0) {
    element.removeAttribute('class');
  }
};

export default removeUnsupportedClassNames;
